// extracted by mini-css-extract-plugin
module.exports = {"imageWrapper":"styles_imageWrapper__3b9xB","imageWrapperError":"styles_imageWrapperError__1hekR","tooltip":"styles_tooltip__17uRI","thumbImage":"styles_thumbImage__2H5QE"};